/* GG Hobby — help bubble (scripted, no AI)
   ---------------------------------------------------------------------------
   A button-driven answer bot. Every answer is copy that already exists on the site
   (the FAQ, the sell page) or a value read from a real Worker feed — nothing is
   generated, so it cannot invent a price, a product, or an opening hour.

   It is deliberately NOT a second funnel. Sell-intent ends at the existing estimator
   + booking form (one funnel, per the owner's rule); the bot only screens eligibility,
   shows real open slots, and hands the seller over with the day/time pre-picked.
   Free text exists on exactly one branch — "something else" — which leaves a message
   the staff reply to from the catalog program.

   Feeds it reads (all public, all best-effort — a dead feed degrades to the safe answer):
     GET /api/buying  -> is the buy list open?    (never offer booking when it's paused)
     GET /api/live    -> is anyone streaming?     (never claim LIVE when they aren't)
     GET /api/book    -> which slots are free     (same call the booking form makes)
   Writes: POST /api/messages.
   Hours/addresses: the STORE and the WAREHOUSE are different places with different
   hours — see FACTS below. Never merge them. */
(function () {
  "use strict";

  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }

  var bookApi = window.GG_BOOK_API || "";
  if (!bookApi) return;                       // no backend wired = no widget
  function api(name) { return String(bookApi).replace(/\/api\/book\/?$/, "/api/" + name); }

  var IS_ES = document.documentElement.lang === "es";
  var SHOPIFY = location.pathname.indexOf("/pages/") !== -1;

  /* ---- slot rules: read from booking.js's published object, never re-declared here ---- */
  var RULES = window.GG_BOOK_RULES || {};
  var OPEN_MIN = RULES.OPEN_MIN || 11 * 60;
  var CLOSE_MIN = RULES.CLOSE_MIN || 18 * 60;
  var SLOT_MINUTES = RULES.SLOT_MINUTES || 30;
  var LUNCH_START = RULES.LUNCH_START || 12 * 60;
  var LUNCH_END = RULES.LUNCH_END || 13 * 60;
  var MIN_NOTICE_MIN = RULES.MIN_NOTICE_MIN || 60;

  /* ---- the two locations. Keep them apart: a seller who walks into the retail store
     is the exact mistake this copy exists to prevent. ---- */
  var FACTS = {
    storeAddress: "20445 Biscayne Blvd, Suite H-4, Aventura, FL 33180",
    storeHours: tr("Open 7 days a week, 11am–6pm"),
    storePhone: "(305) 952-3971",
    warehouse: RULES.WAREHOUSE || "13201 NE 16th Ave, North Miami, FL 33161",
    email: RULES.EMAIL || "gghobbycard@gmail.com",
  };

  var CONSENT_TEXT = IS_ES
    ? "msg-comms-es-v1: Acepto que GG Hobby responda a este mensaje por correo electronico."
    : "msg-comms-v1: I agree that GG Hobby may reply to this message by email.";

  /* ---- page-aware links (static site vs Shopify pages vs Spanish mirrors) ---- */
  function sellUrl() { return SHOPIFY ? "/pages/sell" : (IS_ES ? "sell-es.html" : "sell.html"); }
  function scheduleUrl() { return SHOPIFY ? "/pages/schedule" : (IS_ES ? "schedule-es.html" : "schedule.html"); }
  function homeUrl() { return SHOPIFY ? "/" : (IS_ES ? "index-es.html" : "index.html"); }
  function homeAnchor(a) { return homeUrl() + "#" + a; }

  /* ---- tiny DOM helpers ---- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function fetchJson(url, opts) {
    return fetch(url, opts || {}).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) {
        return { ok: r.ok, status: r.status, data: j };
      });
    });
  }

  /* ---- temporary no-buy list (pushed from the shop program via /api/nobuy) ----
     Prefetched when the bubble opens, so the exclusions answer can include it without
     an await. Fails soft: fetch pending or down = the static answer stands alone. */
  var noBuy = null;
  function loadNoBuy() {
    if (noBuy !== null) return;
    noBuy = { items: [] };
    fetchJson(api("nobuy")).then(function (r) {
      if (r.ok && r.data && Array.isArray(r.data.items)) noBuy = r.data;
    }).catch(function () {});
  }

  /* ---- live thread ----------------------------------------------------------
     After someone sends a message we keep watching their thread while the bubble
     is open. If staff answer from the program in the next few minutes, the reply
     lands right here in the conversation instead of only in their inbox.

     Deliberately NOT advertised anywhere in the copy. The promise stays "we reply
     by email, usually within 1 business day" — always true, never late. Seeing a
     reply appear is a bonus for whoever happens to still be here; anyone who has
     closed the tab is served exactly as before, by email. A promise we can't
     staff at 2am is worse than no promise. */
  var LIVE_KEY = "gg_chat_thread";
  var livePoll = null;
  var liveSeen = 0;          // replies already rendered, so a re-poll doesn't repeat them

  function saveThread(ref, token) {
    try { localStorage.setItem(LIVE_KEY, JSON.stringify({ ref: ref, token: token, at: Date.now() })); } catch (e) {}
  }
  function loadThread() {
    try {
      var t = JSON.parse(localStorage.getItem(LIVE_KEY) || "null");
      // A week is plenty: past that, the conversation has moved to email.
      if (!t || !t.ref || !t.token || (Date.now() - (t.at || 0)) > 7 * 864e5) return null;
      return t;
    } catch (e) { return null; }
  }
  function stopLive() { if (livePoll) { clearInterval(livePoll); livePoll = null; } }

  // Poll while the bubble is open. 4s is well inside "feels instant" for a chat
  // and costs a handful of reads per conversation.
  function startLive(onReply) {
    stopLive();
    var t = loadThread();
    if (!t) return;
    var tick = function () {
      if (!root.classList.contains("is-open")) return;      // don't poll a closed bubble
      fetchJson(api("messages/thread") + "?ref=" + encodeURIComponent(t.ref) + "&token=" + encodeURIComponent(t.token))
        .then(function (r) {
          if (!r.ok || !r.data || !r.data.ok) return;        // 404/503 → quietly stay on email
          var replies = r.data.replies || [];
          for (var i = liveSeen; i < replies.length; i++) onReply(replies[i]);
          liveSeen = replies.length;
        })
        .catch(function () { /* offline / blocked — the email still arrives */ });
    };
    tick();
    livePoll = setInterval(tick, 4000);
  }

  /* Once a thread exists the customer can keep talking — a chat where only one
     side may speak isn't a chat. Their follow-up goes to the Worker, which
     writes it to KV (so it reaches the staff board, not just their screen),
     flips the thread back to unanswered, and pings Discord.

     Still no live promise in the copy: the placeholder says replies come by
     email. If nobody is at the board, their message is waiting there and the
     conversation continues in their inbox exactly as before. */
  function showReplyBox() {
    actions.innerHTML = "";
    panel.classList.add("has-form");

    var form = el("form", "ggchat__form");
    var wrap = el("label", "ggchat__field");
    var input = el("textarea");
    input.rows = 2;
    input.placeholder = tr("Write back… we'll reply here or by email.");
    input.required = true;
    wrap.appendChild(input);
    form.appendChild(wrap);

    var status = el("p", "ggchat__status");
    form.appendChild(status);

    var send = el("button", "ggchat__btn ggchat__btn--primary", tr("Send"));
    send.type = "submit";
    form.appendChild(send);
    actions.appendChild(form);

    var back = el("button", "ggchat__btn", tr("← Back to the menu"));
    back.type = "button";
    back.addEventListener("click", showMenu);
    actions.appendChild(back);
    scrollDown();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var text = (input.value || "").trim();
      if (!text) return;
      var t = loadThread();
      if (!t) { status.textContent = tr("Something went wrong — try again."); return; }
      send.disabled = true;
      status.textContent = tr("Sending…");
      said(text);                       // show it immediately; don't wait on the round trip
      input.value = "";
      fetchJson(api("messages/thread/reply"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ref: t.ref, token: t.token, body: text }),
      })
        .then(function (r) {
          send.disabled = false;
          if (!r.ok || !r.data || !r.data.ok) {
            status.textContent = (r.data && r.data.error) || tr("That didn't send — email us and we'll pick it up.");
            return;
          }
          status.textContent = "";
          liveSeen++;                   // our own line is now in the thread; don't re-render it
        })
        .catch(function () {
          send.disabled = false;
          status.textContent = tr("That didn't send — email us and we'll pick it up.");
        });
    });
  }

  /* ---- shell ---------------------------------------------------------------- */
  var root = el("div", "ggchat");
  var launcher = el("button", "ggchat__launcher");
  launcher.type = "button";
  launcher.setAttribute("aria-label", tr("Questions? Ask us"));
  launcher.innerHTML = '<span class="ggchat__launcher-icon" aria-hidden="true">💬</span>';
  launcher.appendChild(el("span", "ggchat__launcher-text", tr("Questions?")));

  var panel = el("div", "ggchat__panel");
  panel.hidden = true;
  panel.setAttribute("role", "dialog");
  panel.setAttribute("aria-label", tr("GG Hobby help"));

  var head = el("div", "ggchat__head");
  var headText = el("div", "ggchat__head-text");
  headText.appendChild(el("strong", null, tr("Ask GG Hobby")));
  headText.appendChild(el("span", null, tr("Answers are instant. Leave a message and a human replies within 1 business day.")));
  var closeBtn = el("button", "ggchat__close", "×");
  closeBtn.type = "button";
  closeBtn.setAttribute("aria-label", tr("Close"));
  head.appendChild(headText);
  head.appendChild(closeBtn);

  var log = el("div", "ggchat__log");
  var actions = el("div", "ggchat__actions");
  panel.appendChild(head);
  panel.appendChild(log);
  panel.appendChild(actions);
  root.appendChild(panel);
  root.appendChild(launcher);

  /* ---- transcript ----------------------------------------------------------- */
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  function bubble(kind) {
    var b = el("div", "ggchat__msg ggchat__msg--" + kind);
    log.appendChild(b);
    return b;
  }
  function say(lines) {
    var b = bubble("bot");
    (lines || []).forEach(function (line) { b.appendChild(el("p", null, line)); });
    scrollDown();
    return b;
  }
  function said(text) {
    var b = bubble("me");
    b.appendChild(el("p", null, text));
    scrollDown();
  }
  /* A staff reply, rendered with the brand mark beside it so it reads like a
     person answering rather than a system notice.

     The logo comes from the Worker (/api/gg-logo.png), not a local asset path:
     this file is served verbatim from the static site AND from Shopify's CDN,
     where "assets/logo.png" would 404. One URL that resolves the same in both
     places — and a white-label operator changes it in one spot.

     The name shown is whatever the program sent (the brand display name), never
     a staff username. */
  function sayReply(who, body) {
    var row = el("div", "ggchat__reply");
    var img = el("img", "ggchat__avatar");
    img.src = api("gg-logo.png");
    img.alt = "";
    img.setAttribute("loading", "lazy");
    // A broken image icon looks worse than no avatar — drop it and keep the text.
    img.addEventListener("error", function () { row.classList.add("is-noavatar"); img.remove(); });
    var b = el("div", "ggchat__msg ggchat__msg--bot");
    b.appendChild(el("strong", "ggchat__reply-who", who));
    b.appendChild(el("p", null, body));
    row.appendChild(img);
    row.appendChild(b);
    log.appendChild(row);
    scrollDown();
  }
  function addLinks(target, links) {
    if (!links || !links.length) return;
    var wrap = el("div", "ggchat__links");
    links.forEach(function (l) {
      var a = el("a", "ggchat__link", l.text);
      a.href = l.href;
      if (l.external) { a.target = "_blank"; a.rel = "noopener"; }
      wrap.appendChild(a);
    });
    target.appendChild(wrap);
    scrollDown();
  }

  function setButtons(items) {
    actions.innerHTML = "";
    // Back to plain buttons — release the taller form layout (see .has-form).
    panel.classList.remove("has-form");
    (items || []).forEach(function (it) {
      var b = el("button", "ggchat__btn" + (it.primary ? " ggchat__btn--primary" : ""), it.label);
      b.type = "button";
      b.addEventListener("click", function () {
        said(it.label);
        it.go();
      });
      actions.appendChild(b);
    });
    scrollDown();
  }

  function backRow(extra) {
    var rows = (extra || []).slice();
    rows.push({ label: tr("← Back to the menu"), go: showMenu });
    return rows;
  }

  function thinking() {
    var b = bubble("bot");
    b.className += " is-thinking";
    b.appendChild(el("p", null, tr("One sec…")));
    scrollDown();
    return b;
  }

  /* ---- menu ----------------------------------------------------------------- */
  function showMenu() {
    say([tr("What can we help with?")]);
    setButtons([
      { label: tr("I want to sell cards to you"), primary: true, go: sellBranch },
      { label: tr("Are you live right now?"), go: liveBranch },
      { label: tr("Where can I buy from you?"), go: buyBranch },
      { label: tr("Store hours & location"), go: storeBranch },
      { label: tr("Selling to you — hours & where"), go: warehouseBranch },
      { label: tr("What's a break? What's a personal?"), go: breaksBranch },
      { label: tr("Refunds & policies"), go: policyBranch },
      { label: tr("Something else — send us a message"), go: messageBranch },
    ]);
  }

  /* ---- store branch (BUY FROM US context: phone is fine here) ---------------- */
  function storeBranch() {
    var b = say([
      tr("Our shop is at {addr}.").replace("{addr}", FACTS.storeAddress),
      FACTS.storeHours + ".",
      tr("Walk right in — no appointment needed. Call us at {phone}.").replace("{phone}", FACTS.storePhone),
      tr("Heads up: selling cards TO us happens somewhere else, by appointment. Different address, different hours."),
    ]);
    addLinks(b, [
      { text: tr("Map & directions →"), href: homeAnchor("visit") },
      { text: tr("Call the shop"), href: "tel:+13059523971" },
    ]);
    setButtons(backRow([
      { label: tr("Wait — where do I go to SELL?"), go: warehouseBranch },
    ]));
  }

  /* ---- warehouse branch (SELL context: email only, never the store phone) ---- */
  function warehouseLines() {
    return [
      tr("Selling to us is by appointment only, at our warehouse — not the Aventura shop."),
      tr("Warehouse: {addr}").replace("{addr}", FACTS.warehouse),
      tr("Buying hours: Monday–Friday, {open}–{close}. We're closed {lunchStart}–{lunchEnd} for lunch, so there are no slots then.").
        replace("{open}", label(OPEN_MIN)).replace("{close}", label(CLOSE_MIN)).
        replace("{lunchStart}", label(LUNCH_START)).replace("{lunchEnd}", label(LUNCH_END)),
      tr("Booking same-day? We need at least {n} minutes' notice.").replace("{n}", MIN_NOTICE_MIN),
      tr("Questions about selling: email {email}.").replace("{email}", FACTS.email),
    ];
  }
  function warehouseBranch() {
    var b = say(warehouseLines());
    addLinks(b, [{ text: tr("Email us about selling"), href: "mailto:" + FACTS.email }]);
    withBuyingState(function (open) {
      setButtons(backRow(open ? [
        { label: tr("Find me a time"), primary: true, go: slotBranch },
        { label: tr("Book a sell appointment →"), go: function () { location.href = sellUrl() + "#book"; } },
      ] : []));
    });
  }

  /* ---- sell branch ---------------------------------------------------------- */
  // Reads the site-wide buying switch the same way booking.js does, and fails OPEN:
  // an unreachable endpoint leaves the normal (buying-on) copy alone.
  function withBuyingState(cb) {
    fetchJson(api("buying"))
      .then(function (r) { cb(!(r && r.data && r.data.enabled === false)); })
      .catch(function () { cb(true); });
  }

  function sellBranch() {
    var t = thinking();
    withBuyingState(function (open) {
      t.remove();
      if (!open) {
        var p = say([
          tr("We're not buying right this second — the buy list is paused while we work through intake."),
          tr("Leave your contact on the sell page and we'll email you the moment buying reopens."),
        ]);
        addLinks(p, [{ text: tr("Get notified when buying reopens →"), href: sellUrl() }]);
        setButtons(backRow());
        return;
      }
      var b = say([
        tr("Yes — we buy sealed Pokémon and select One Piece, and we pay strong: up to 85% of market on Pokémon, 80% on One Piece — and 90% on all 30th Anniversary product and the Charizard & Moltres Ultra-Premium Collections right now."),
        tr("Everything has to be factory sealed and pristine."),
        tr("It's by appointment at our warehouse — {addr} — not the Aventura shop.").replace("{addr}", FACTS.warehouse),
      ]);
      addLinks(b, [{ text: tr("Build your list & get an estimate →"), href: sellUrl() + "#estimator" }]);
      setButtons(backRow([
        { label: tr("Find me a time"), primary: true, go: slotBranch },
        { label: tr("What don't you take?"), go: exclusionsBranch },
        { label: tr("Where exactly do I go?"), go: warehouseBranch },
      ]));
    });
  }

  function exclusionsBranch() {
    var lines = [
      tr("We don't take booster boxes of any type, Pokémon blisters or loose packs, Halloween/trick-or-treat packs, Prismatic Evolutions booster bundles, or anything damaged."),
      tr("One Piece is the exception: we DO take One Piece single booster packs and blisters — at 80% of market."),
      tr("Sealed and pristine only — if a box has been opened or resealed, we can't take it."),
    ];
    // temporary pauses the program pushed — loaded when the bubble opened
    if (noBuy && noBuy.items && noBuy.items.length) {
      lines.push(tr("Also paused right now (these may come back): {list}").replace("{list}",
        noBuy.items.map(function (x) { return x && x.label; }).filter(Boolean).join(", ")));
    }
    lines.push(tr("Not sure about something you've got? Send us a message and we'll tell you straight."));
    say(lines);
    setButtons(backRow([
      { label: tr("Find me a time"), go: slotBranch },
      { label: tr("Ask about a specific item"), go: messageBranch },
    ]));
  }

  /* ---- assisted booking: real slots in the bubble, then hand off to the form ---
     The bot never books. It reads the same availability endpoint the form reads, then
     deep-links to the form with ?d=&t= so the seller lands on the estimator + booking
     with the time already chosen. One booking form, one POST, one consent record. */
  function label(min) {
    var h = Math.floor(min / 60), m = min % 60;
    var ampm = h >= 12 ? "PM" : "AM";
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + ":" + String(m).padStart(2, "0") + " " + ampm;
  }
  function nowET() {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York", year: "numeric", month: "2-digit",
      day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false,
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    var hr = o.hour === "24" ? 0 : parseInt(o.hour, 10);
    return { date: o.year + "-" + o.month + "-" + o.day, minutes: hr * 60 + parseInt(o.minute, 10) };
  }
  // the next few weekdays, starting today — the warehouse takes no weekend appointments
  function nextWeekdays(n) {
    var out = [], d = new Date(nowET().date + "T12:00:00");
    while (out.length < n) {
      var day = d.getDay();
      if (day >= 1 && day <= 5) {
        out.push({
          value: d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"),
          label: d.toLocaleDateString(IS_ES ? "es-US" : "en-US", { weekday: "short", month: "short", day: "numeric" }),
        });
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }

  function slotBranch() {
    say([tr("Pick a day and I'll show you what's actually open.")]);
    setButtons(backRow(nextWeekdays(5).map(function (d) {
      return { label: d.label, go: function () { showSlots(d); } };
    })));
  }

  function showSlots(day) {
    var t = thinking();
    fetchJson(api("book") + "?date=" + encodeURIComponent(day.value))
      .then(function (r) {
        t.remove();
        var busy = (r && r.data && r.data.busy) || [];
        var et = nowET();
        var isToday = day.value === et.date;
        var free = [];
        for (var min = OPEN_MIN; min < CLOSE_MIN; min += SLOT_MINUTES) {
          if (min >= LUNCH_START && min < LUNCH_END) continue;           // lunch — no slot
          if (isToday && min < et.minutes + MIN_NOTICE_MIN) continue;    // too soon today
          if (busy.indexOf(label(min)) !== -1) continue;                 // already booked
          free.push(label(min));
        }
        if (!free.length) {
          say([tr("Nothing open on {day}. Try another day?").replace("{day}", day.label)]);
          setButtons(backRow([{ label: tr("Pick another day"), go: slotBranch }]));
          return;
        }
        say([tr("Open on {day}:").replace("{day}", day.label)]);
        setButtons(backRow([{ label: tr("Pick another day"), go: slotBranch }].concat(
          free.map(function (slot) {
            return { label: slot, go: function () { confirmSlot(day, slot); } };
          })
        )));
      })
      .catch(function () {
        t.remove();
        say([tr("Couldn't load times just now — the booking form has the live calendar.")]);
        setButtons(backRow([{ label: tr("Open the booking form →"), go: function () { location.href = sellUrl() + "#book"; } }]));
      });
  }

  function confirmSlot(day, slot) {
    var href = sellUrl() + "?d=" + encodeURIComponent(day.value) + "&t=" + encodeURIComponent(slot) + "#book";
    var b = say([
      tr("{day} at {slot} it is.").replace("{day}", day.label).replace("{slot}", slot),
      tr("Last step: add what you're bringing so we can price it, then confirm your details. Your day and time are already filled in."),
      tr("Remember — it's the warehouse: {addr}.").replace("{addr}", FACTS.warehouse),
    ]);
    addLinks(b, [{ text: tr("Finish booking →"), href: href }]);
    setButtons(backRow([
      { label: tr("Finish booking →"), primary: true, go: function () { location.href = href; } },
      { label: tr("Pick another time"), go: slotBranch },
    ]));
  }

  /* ---- live branch (never claims LIVE unless the feed says so) --------------- */
  function liveBranch() {
    var t = thinking();
    fetchJson(api("live"))
      .then(function (r) {
        t.remove();
        var sessions = (r && r.data && r.data.sessions) || [];
        if (!sessions.length) {
          var q = say([
            tr("Nobody's live this second."),
            tr("We stream seven days a week though — the schedule has who's on and when."),
          ]);
          addLinks(q, [{ text: tr("See the schedule →"), href: scheduleUrl() }]);
          setButtons(backRow());
          return;
        }
        var lines = [sessions.length > 1
          ? tr("{n} shows are live right now:").replace("{n}", sessions.length)
          : tr("Yes — we're live right now:")];
        sessions.slice(0, 6).forEach(function (s) {
          lines.push((s.streamer || "GG Hobby") + " · " + (s.channel || tr("live")));
        });
        var b = say(lines);
        addLinks(b, sessions.slice(0, 6).filter(function (s) { return s.url; }).map(function (s) {
          return { text: tr("Watch {who} →").replace("{who}", s.streamer || tr("live")), href: s.url, external: true };
        }));
        setButtons(backRow());
      })
      .catch(function () {
        t.remove();
        var b = say([tr("Couldn't check the live feed just now — the schedule page has tonight's lineup.")]);
        addLinks(b, [{ text: tr("See the schedule →"), href: scheduleUrl() }]);
        setButtons(backRow());
      });
  }

  /* ---- static FAQ branches (copy lifted from the site's own FAQ) ------------- */
  function buyBranch() {
    var b = say([
      tr("Live on our streams — TikTok, eBay Live and Whatnot — or in person at the shop in Aventura."),
      tr("Our online store is coming very soon, so you'll be able to shop the whole wall right here."),
    ]);
    addLinks(b, [
      { text: tr("See what's in stock →"), href: homeAnchor("inventory") },
      { text: tr("Tonight's streams →"), href: homeAnchor("live") },
    ]);
    setButtons(backRow([{ label: tr("Are you live right now?"), go: liveBranch }]));
  }

  function breaksBranch() {
    var b = say([
      tr("A break is a group rip: a sealed box or case gets opened live on stream and buyers claim spots, often by team or player — whatever hits in your spot is yours."),
      tr("A personal is a box ripped live just for you: you buy it, we open it on camera, and everything inside ships to you."),
      tr("Slab = a card graded and sealed by PSA, BGS or CGC. Wax = sealed packs and boxes. Hit = the big card in the box."),
    ]);
    addLinks(b, [{ text: tr("Watch a break →"), href: homeAnchor("live") }]);
    setButtons(backRow());
  }

  function policyBranch() {
    var b = say([
      tr("All sales on our live streams are final — it's posted in every game."),
      tr("Online-store orders follow our refund policy."),
    ]);
    addLinks(b, [
      { text: tr("Refund policy →"), href: "https://gghobbycard.com/policies/refund-policy", external: true },
      { text: tr("Privacy policy →"), href: "https://gghobbycard.com/policies/privacy-policy", external: true },
    ]);
    setButtons(backRow());
  }

  /* ---- message form: the only free-text path -------------------------------- */
  var lastTopic = "general";
  function messageBranch() {
    say([
      tr("Tell us what you need and we'll get back to you by email — usually within 1 business day."),
    ]);
    actions.innerHTML = "";
    // Six fields don't fit the default action strip — this hands the form the
    // leftover space and lets the transcript above it shrink. Set on the panel
    // (not the actions box) so the CSS needs no :has() support.
    panel.classList.add("has-form");

    var form = el("form", "ggchat__form");
    function field(label, type, name, required) {
      var wrap = el("label", "ggchat__field");
      wrap.appendChild(el("span", null, label));
      var input = type === "textarea" ? el("textarea") : el("input");
      if (type !== "textarea") input.type = type;
      input.name = name;
      if (required) input.required = true;
      if (type === "textarea") input.rows = 3;
      wrap.appendChild(input);
      form.appendChild(wrap);
      return input;
    }
    var fName = field(tr("Your name"), "text", "name", true);
    var fEmail = field(tr("Email"), "email", "email", true);
    var fPhone = field(tr("Phone (optional)"), "tel", "phone", false);
    var fMsg = field(tr("What's up?"), "textarea", "message", true);

    // honeypot — same trick the booking form uses; real people never fill this in
    var hp = el("input", "ggchat__hp");
    hp.type = "text";
    hp.name = "website";
    hp.tabIndex = -1;
    hp.setAttribute("autocomplete", "off");
    hp.setAttribute("aria-hidden", "true");
    form.appendChild(hp);

    var consentWrap = el("label", "ggchat__consent");
    var consent = el("input");
    consent.type = "checkbox";
    consent.required = true;
    consentWrap.appendChild(consent);
    consentWrap.appendChild(el("span", null, tr("I agree that GG Hobby may reply to this message by email.")));
    form.appendChild(consentWrap);

    var status = el("p", "ggchat__status");
    form.appendChild(status);

    var submit = el("button", "ggchat__btn ggchat__btn--primary", tr("Send message"));
    submit.type = "submit";
    form.appendChild(submit);
    actions.appendChild(form);

    var cancel = el("button", "ggchat__btn", tr("← Back to the menu"));
    cancel.type = "button";
    cancel.addEventListener("click", showMenu);
    actions.appendChild(cancel);
    scrollDown();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var payload = {
        name: fName.value.trim(),
        email: fEmail.value.trim(),
        phone: fPhone.value.trim(),
        message: fMsg.value.trim(),
        website: hp.value,
        topic: lastTopic,
        page: location.pathname,
        lang: IS_ES ? "es" : "en",
        consentText: CONSENT_TEXT,
      };
      if (!payload.name || !payload.email || !payload.message) {
        status.textContent = tr("Please fill in your name, email, and message.");
        return;
      }
      submit.disabled = true;
      status.textContent = tr("Sending…");
      fetchJson(api("messages"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          if (!r.ok) {
            submit.disabled = false;
            status.textContent = (r.data && r.data.error) || tr("Something went wrong — try again.");
            return;
          }
          actions.innerHTML = "";
          say([
            tr("Got it — thanks."),
            tr("We reply by email, usually within 1 business day."),
            r.data && r.data.ref ? tr("Your reference: {ref}").replace("{ref}", r.data.ref) : "",
          ].filter(Boolean));
          // Watch for a reply while they're still here. The copy above already
          // promised email and nothing more — anything that shows up now is a
          // bonus, so there is nothing to walk back if no one is at the board.
          if (r.data && r.data.ref && r.data.token) {
            saveThread(r.data.ref, r.data.token);
            liveSeen = 0;
            showReplyBox();
            startLive(function (reply) {
              // Their own follow-ups come back on the next poll too — skip
              // those, they're already on screen.
              if (reply.mine) return;
              sayReply(reply.by || "GG Hobby", reply.body);
            });
          } else {
            setButtons([{ label: tr("← Back to the menu"), go: showMenu }]);
          }
        })
        .catch(function () {
          // never lose a message: fall back to a prefilled email, same as the booking form
          submit.disabled = false;
          status.textContent = tr("Opening an email so we still get your message…");
          location.href = "mailto:" + FACTS.email +
            "?subject=" + encodeURIComponent(tr("Website message — {name}").replace("{name}", payload.name)) +
            "&body=" + encodeURIComponent(payload.message + "\n\n" + payload.name + "\n" + payload.email + "\n" + payload.phone);
        });
    });
  }

  /* ---- open / close --------------------------------------------------------- */
  var started = false;
  function openPanel() {
    loadNoBuy();               // warm the paused-items list for the exclusions answer
    panel.hidden = false;
    root.classList.add("is-open");
    launcher.setAttribute("aria-expanded", "true");
    try { localStorage.setItem("gg_chat_seen", "1"); } catch (e) {}
    if (!started) {
      started = true;
      // opening on the sell page? start where they already are.
      if (/sell/.test(location.pathname)) {
        lastTopic = "sell";
        say([tr("Selling to us? I can check open appointment times and tell you what we take.")]);
        setButtons([
          { label: tr("Find me a time"), primary: true, go: slotBranch },
          { label: tr("What don't you take?"), go: exclusionsBranch },
          { label: tr("Where exactly do I go?"), go: warehouseBranch },
          { label: tr("Something else — send us a message"), go: messageBranch },
        ]);
      } else {
        showMenu();
      }
    }
  }
  function closePanel() {
    panel.hidden = true;
    root.classList.remove("is-open");
    launcher.setAttribute("aria-expanded", "false");
    stopLive();          // no polling behind a closed bubble
  }
  launcher.addEventListener("click", function () {
    if (panel.hidden) openPanel(); else closePanel();
  });
  closeBtn.addEventListener("click", closePanel);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) closePanel();
  });

  launcher.setAttribute("aria-expanded", "false");
  document.body.appendChild(root);
})();
